'use strict';
angular.module('theme').component('weekendBanner', {
	templateUrl: 'component/weekend-banner.html',
	controller: function($rootScope, $scope, $window, $cookies) {

		$scope.showBanner = !$cookies.get('hide-weekend-banner');

		$scope.close = function() {
			$scope.showBanner = false;
			$cookies.put('hide-weekend-banner', true, {
				path: '/',
				expires: moment().add(3, 'month').toDate()
			});
		};

		$rootScope.$watch('acceptCookies', function(val) {
			$scope.acceptCookies = val;
		});
	}
});
